module.exports = __webpack_public_path__ + "img/child cancer.42a96c22.jpg";